import { render, staticRenderFns } from "./HouseholdMonthlyIncome.vue?vue&type=template&id=d95e3aea&scoped=true&"
import script from "./HouseholdMonthlyIncome.vue?vue&type=script&lang=js&"
export * from "./HouseholdMonthlyIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95e3aea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
